export const fmt = (v) => (v === null || v === undefined || v === "" ? "—" : String(v));